import { render, staticRenderFns } from "./WelcomePart.vue?vue&type=template&id=4893b526&"
import script from "./WelcomePart.vue?vue&type=script&lang=js&"
export * from "./WelcomePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports